import { Link } from "react-router-dom";

interface Props {
    type: any,
}

function ErrorPage(props: Props) {

    return (
        <>
            <div>Error In Page {props.type}</div>
            <Link to="/">retornar a página inicial</Link>
        </>
    )
}

export default ErrorPage;
